import { render } from "./s3.vue?vue&type=template&id=285a3132&scoped=true"
import script from "./s3.vue?vue&type=script&lang=js"
export * from "./s3.vue?vue&type=script&lang=js"

import "./s3.vue?vue&type=style&index=0&id=285a3132&lang=scss&scoped=true"

import exportComponent from "../../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-285a3132"]])

export default __exports__